import React from 'react';
import { Hammer, Package, PackageCheck, FileBarChart, Tag } from 'lucide-react';
import GenericSectionDashboard from '../GenericSectionDashboard';
import { JoStuckBanner, STAGE_SETS } from '@/components/processingJo/JoStuckBanner';

const FlexiDashboard = () => {
  const customTiles = [
    {
      id: 'flexi-fg-assignment',
      title: 'FG Assignment',
      description: 'Assign an FG item to bundles received in Flexi',
      icon: Tag,
      iconBg: 'bg-amber-600',
      route: '/sections/flexi/fg-assignment',
      testId: 'flexi-fg-assignment-tile',
      priority: true,
    },
    {
      id: 'flexi-hub',
      title: 'Job-Work Hub',
      description: 'Flexi JW Orders & lifecycle',
      icon: Hammer,
      iconBg: 'bg-purple-600',
      route: '/sections/flexi/hub',
      testId: 'flexi-hub-tile',
      priority: true,
    },
    {
      id: 'flexi-receipt',
      title: 'Job Order Receipt',
      description: 'Scan assembled USNs back & tally against the job order',
      icon: PackageCheck,
      iconBg: 'bg-blue-600',
      route: '/sections/flexi/receipt',
      testId: 'flexi-receipt-tile',
      priority: true,
    },
    {
      id: 'flexi-jw-report',
      title: 'Job Order Report',
      description: 'Sent vs receipted, balance, age & pure/force close',
      icon: FileBarChart,
      iconBg: 'bg-rose-600',
      route: '/sections/flexi/jw-report',
      testId: 'flexi-jw-report-tile',
      priority: true,
    },
    {
      id: 'flexi-assortment',
      title: 'Flexi Assortment',
      description: 'Pack assortment boxes for Internal Transfer',
      icon: Package,
      iconBg: 'bg-emerald-600',
      route: '/sections/flexi/assortment',
      testId: 'flexi-assortment-tile',
      priority: true,
    },
  ];

  return (
    <GenericSectionDashboard
      sectionName="Flexi Section"
      sectionId="flexi"
      sectionKey="Flexi"
      description="Flexible Packaging Operations"
      backRoute="/"
      customTiles={customTiles}
      headerExtras={<JoStuckBanner stages={STAGE_SETS.flexi} testId="flexi-jo-stuck-banner" />}
    />
  );
};

export default FlexiDashboard;
